import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { Button } from '@beef/ui-kit';

import { setFiltersBarClose } from 'store/ProductCatalog/controls/actions';
import { getCatalogTotalCount } from 'store/ProductCatalog/products/selectors';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const formatProductLabel = (count) => {
  const lastSym = `${count}`.slice(-1);
  /* eslint-disable radix */
  const lastSymNumber = parseInt(lastSym);

  if (lastSymNumber === 0) {
    return 'товаров';
  }

  if (lastSymNumber === 1) {
    return 'товар';
  }

  if (lastSymNumber < 5) {
    return 'товара';
  }

  return 'товаров';
};

export function SidebarFooterComponent({ isMobile, totalCount, onClick }) {
  return (
    <div className={cx('component')}>
      <Button
        onClick={onClick}
        role="button"
        tabIndex={0}
        size="m"
        type="button"
        variant="secondary"
        fullWidth={isMobile}
      >
        Показать {totalCount} {formatProductLabel(totalCount)}
      </Button>
    </div>
  );
}

SidebarFooterComponent.propTypes = {
  isMobile: PropTypes.bool,
  totalCount: PropTypes.number,
  onClick: PropTypes.any,
};

const mapStateToProps = (state) => ({
  totalCount: getCatalogTotalCount(state),
});

const mapDispatchToProps = {
  onClick: setFiltersBarClose,
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarFooterComponent);
